module.exports = __webpack_public_path__ + "static/img/r_3.e18217bc.png";